/**
 * Returns the canonical form of a locale name - lowercase with `_` replaced with `-`.
 */
export const normalizeLocale: (locale: string) => string = (locale: string): string => {
    return locale.toLowerCase().replace(/_/g, '-');
};
